<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eDBEzF/Images/cover.jpg?1685327423023" alt="This image is the cover for the book Best Laid Trap, 2015 Advent Calendar - Sleigh Ride"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Best Laid Trap, 2015 Advent Calendar - Sleigh Ride
      </h1>
      <p class="bookDescription body article font2">
        <p>Roy has a crush on Steve, so when a work-related ski weekend is offered, Roy jumps at the chance to finally lay a trap for his hunky coworker. An abandoned cabin nearby is perfect for his scheme, and Roy stocks it with champagne, rubbers, and lube. But fate intervenes, and it’s not Steve, but Ranger Josh, who ends up trapped in the cabin with Roy during an avalanche. Roy’s plan might be ruined, but there’s still a chance for a very happy New Year indeed.</p><p><i>A story from the Dreamspinner Press 2015 Advent Calendar package "Sleigh Ride".</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rob Rosen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a1400ec